import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Crown, Music, ArrowRight, Check } from 'lucide-react';

export const BillingSuccessPage = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    // Refresh user data to get updated Pro status
    checkAuth();
  }, [checkAuth]);

  return (
    <div className="min-h-screen bg-ss-bg flex items-center justify-center px-4">
      <div className="noise-overlay"></div>

      <Card className="bg-ss-surface border-ss-cyan/30 max-w-md w-full animate-slide-up">
        <CardContent className="py-12 text-center">
          {/* Success Icon */}
          <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-gradient-to-br from-ss-cyan/20 to-ss-gold/20 border-2 border-ss-cyan flex items-center justify-center">
            <div className="w-16 h-16 rounded-full bg-ss-cyan flex items-center justify-center">
              <Check className="w-10 h-10 text-black" strokeWidth={3} />
            </div>
          </div>

          {/* Title */}
          <div className="flex items-center justify-center gap-2 mb-4">
            <Crown className="w-8 h-8 text-ss-gold" />
            <h1 className="font-heading text-3xl font-black tracking-tight text-ss-text">
              You're Pro!
            </h1>
            <Music className="w-6 h-6 text-ss-cyan" />
          </div>

          {/* Message */}
          <p className="text-ss-muted mb-8 text-lg">
            Your Pro access is now active. Enjoy unlimited copedants, grip results, and advanced filters!
          </p>

          {/* Features unlocked */}
          <div className="space-y-3 mb-8 text-left">
            <div className="flex items-center gap-3 p-3 bg-ss-bg rounded-lg border border-ss-border">
              <Check className="w-5 h-5 text-ss-cyan" />
              <span className="text-ss-text">Unlimited saved copedants</span>
            </div>
            <div className="flex items-center gap-3 p-3 bg-ss-bg rounded-lg border border-ss-border">
              <Check className="w-5 h-5 text-ss-cyan" />
              <span className="text-ss-text">Unlimited grip search results</span>
            </div>
            <div className="flex items-center gap-3 p-3 bg-ss-bg rounded-lg border border-ss-border">
              <Check className="w-5 h-5 text-ss-cyan" />
              <span className="text-ss-text">Advanced chord quality filters</span>
            </div>
          </div>

          {/* CTA Button */}
          <Button
            onClick={() => navigate('/dashboard')}
            data-testid="go-to-explorer-btn"
            className="w-full h-14 bg-ss-cyan hover:bg-ss-cyan/90 text-black font-bold text-lg"
          >
            Go to Explorer
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default BillingSuccessPage;
